module.exports = __webpack_public_path__ + "img/niño52.706dd796.jpg";